import React from 'react';
import { Text } from 'grommet';

export default function BodyText({ size, ...rest }) {
  return <Text size={size} weight="normal" color="#272727" fontFamily="Roboto Slab" {...rest} />;
}
